export default __webpack_public_path__ + "static/image19-13c657b33f44e5dffeb0e8b19dc30ae8.gif";